module.exports = __webpack_public_path__ + "img/vehicle-safety.334bf34f.jpg";